// @ is an alias to /src
// import { imgMap } from '@/utils';

// 以下两行代码 运行状况未知
// import { EggConsoleLogger } from 'egg-logger';
// import { runInThisContext } from 'vm';
import countryMinix from '../../countryList/countryList';

// const upload1 = imgMap.kyc_idcard_a;
// const upload2 = imgMap.kyc_idcard_b;
// const upload3 = imgMap.kyc_idcard_c;
// const upload4 = imgMap.kyc_passport_a;
// const upload5 = imgMap.kyc_passport_b;
// const upload6 = imgMap.kyc_passport_c;

export default {
  name: 'bindEmail',
  mixins: [countryMinix],
  data() {
    return {
      promptTextType: this.$t('personal.idAuth.promptTextType'),
      promptText: this.$t('personal.label.promptText'),
      errorText: this.$t('personal.label.errorText'),
      authLevel: 3,
      text1: this.$t('personal.label.idCard'),
      text2: this.$t('personal.label.passport'),
      loading: false,

      firstPhotoImg: '',
      secondPhotoImg: '',
      thirdPhotoImg: '',
      fourthPhotoImg: '',
      fifthPhotoImg: '',
      sixthPhotoImg: '',

      firstPhotoLoading: false,
      secondPhotoLoading: false,
      thirdPhotoLoading: false,
      fourthPhotoLoading: false,
      fifthPhotoLoading: false,
      sixthPhotoLoading: false,

      checkValue1: '', // 证件号
      promptText1: this.$t('personal.label.idCardNum'),
      errorText1: '',
      checkErrorFlag1: false,
      checkValue2: '', // 姓名
      promptText2: this.$t('personal.label.name'),
      active: '1',
      disabled2: true,
      country: '', // 国家编号
      countryErrorFlag: false,
      certificateType: 2, // 证件类型
      certificateTypeErrorFlag: false,
      imageType: '1',
      firstPhoto: '', // 身份证正面
      secondPhoto: '', // 身份证反面
      thirdPhoto: '', // 手持证件
      fourthPhoto: '',
      fifthPhoto: '',
      sixthPhoto: '',
      uploadName: '', // 当前选中的上传模块
      kycPhone: '', // kyc选择的国家
      kycPhoneCode: '',
      kycName: '', // kyc 外国 - 名
      kycFamilyName: '', // kyc 外国 - 姓
      kycMetaText: '', // 上传图片说明文案
      flag: false, // 二维码

      certificateType1: '', // 证件类型1
      certificateType2: '', // 证件类型2
      certificateType1PromptText: `${this.$t('personal.kyc.type')}1(${this.$t('personal.kyc.require')})`, // 证件类型1 label文本
      certificateType2PromptText: `${this.$t('personal.kyc.type')}2(${this.$t('personal.kyc.Optional')})`, // 证件类型2 label文本
      certificateType1NumPromptText: '', // 证件号码1 label文本
      certificateType2NumPromptText: '', // 证件号码2 label文本
      certificateType1Value: '', // 证件号码1 内容
      certificateType2Value: '', // 证件号码2 内容
      address: '', // 地址
      // type1: '护照',
      // type2: '驾照',
      // type3: '身份证',
      // type4: '其他合法证件',
      name: `${this.$t('personal.kyc.name')}(${this.$t('personal.kyc.require')})`,
      fName: `${this.$t('personal.kyc.fName')}(${this.$t('personal.kyc.require')})`,
      idAuthType: [ // 证件类型枚举
        {
          code: 1,
          value: this.$t('personal.kyc.type1'),
        },
        {
          code: 2,
          value: this.$t('personal.kyc.type2'),
        },
        {
          code: 3,
          value: this.$t('personal.kyc.type3'),
        },
        {
          code: 4,
          value: this.$t('personal.kyc.type4'),
        },
      ],
      certificateType1Options: [ // 证件类型枚举
        {
          code: 1,
          value: this.$t('personal.kyc.type1'),
        },
        {
          code: 2,
          value: this.$t('personal.kyc.type2'),
        },
        {
          code: 3,
          value: this.$t('personal.kyc.type3'),
        },
        {
          code: 4,
          value: this.$t('personal.kyc.type4'),
        },
      ],
      certificateType2Options: [ // 证件类型枚举
        {
          code: 1,
          value: this.$t('personal.kyc.type1'),
        },
        {
          code: 2,
          value: this.$t('personal.kyc.type2'),
        },
        {
          code: 3,
          value: this.$t('personal.kyc.type3'),
        },
        {
          code: 4,
          value: this.$t('personal.kyc.type4'),
        },
      ],
    };
  },
  watch: {
    interfaceSwitch(v) {
      if (v) {
        this.getLang();
      }
    },
    userInfo(v) {
      if (v) {
        this.authLevel = this.userInfo.authLevel;
        if (this.authLevel === 2 || this.authLevel === 3) {
          this.active = '1';
        } else if (this.authLevel === 0) {
          this.active = '3';
        } else {
          // this.authLevel为1 审核通过
          this.$router.push('/personal/userManagement');
        }
      }
    },
    publicInfo(v) {
      if (v) {
        this.isOpenUploadImg = this.publicInfo.switch.is_open_upload_img;
      }
    },
    authRealname(authRealname) {
      if (authRealname !== null) {
        this.loading = false;
        if (authRealname.text === 'success') {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'success' });
          this.active = '3';
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('tip', { text: authRealname.msg, type: 'error' });

          this.firstPhotoImg = '';
          this.secondPhotoImg = '';
          this.thirdPhotoImg = '';
          this.fourthPhotoImg = '';
          this.fifthPhotoImg = '';
          this.sixthPhotoImg = '';

          this.firstPhotoLoading = false;
          this.secondPhotoLoading = false;
          this.thirdPhotoLoading = false;

          this.checkValue1 = '';
          this.checkValue2 = '';

          this.disabled2 = true;
          this.active = '1';

          this.firstPhoto = '';
          this.secondPhoto = '';
          this.thirdPhoto = '';
          this.fourthPhoto = '';
          this.fifthPhoto = '';
          this.sixthPhoto = '';

          this.uploadName = '';
          this.kycName = '';
          this.kycFamilyName = '';
          this.$store.dispatch('resetType');
        }
      }
    },
    appDownload(v) {
      if (v) { this.flag = true; }
    },
  },
  computed: {
    interfaceSwitch() {
      return this.$store.state.baseData.interfaceSwitch;
    },
    appAuthOpen() {
      return this.$store.state.baseData.app_auth_open;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    positive() {
      if (this.kycType === '1') {
        return { backgroundImage: 'url(https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210715012414304.png)' };
      }
      return { backgroundImage: 'url(https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210715013334641.png)' };
    },
    reverse() {
      if (this.kycType === '1') {
        return { backgroundImage: 'url(https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210715012459445.png)' };
      }
      return { backgroundImage: 'url(https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210715013535916.png)' };
    },
    handheld() {
      if (this.kycType === '1') {
        return { backgroundImage: 'url(https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210715012525092.png)' };
      }
      return { backgroundImage: 'url(https://vdollarex.oss-ap-southeast-1.aliyuncs.com/upload/20210715013644971.png)' };
    },
    // bg1() {
    //   if (this.kycType === '1') {
    //     return { backgroundImage: `url(${upload1})` };
    //   }
    //   return {
    //     backgroundImage: `url(${upload5})`,
    //   };
    // },
    // bg2() {
    //   if (this.kycType === '1') {
    //     return {
    //       backgroundImage: `url(${upload2})`,
    //     };
    //   }
    //   return {
    //     backgroundImage: `url(${upload4})`,
    //   };
    // },
    // bg3() {
    //   if (this.kycType === '1') {
    //     return {
    //       backgroundImage: `url(${upload3})`,
    //     };
    //   }
    //   return {
    //     backgroundImage: `url(${upload6})`,
    //   };
    // },
    authRealname() {
      return this.$store.state.personal.authRealname;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    activeP1() {
      if (this.active !== '1') {
        return '';
      }
      return 'b-2-cl';
    },
    activeP2() {
      if (this.active !== '2') {
        return '';
      }
      return 'b-2-cl';
    },
    activeP3() {
      if (this.active === '3') {
        return 'b-2-cl';
      }
      return '';
    },
    activeS2() {
      if (this.active !== '1') {
        return 'a-12-bg';
      }
      return 'a-1-bg';
    },
    activeS3() {
      if (this.active === '3') {
        return 'a-12-bg';
      }
      return 'a-1-bg';
    },
    // kyc第一步骤
    kycStep1Disabled() {
      let flag = true;
      // console.log('into');
      if (
        this.kycNationality// 国籍
        && this.certificateType1 // 证件类型1
        && this.certificateType1Value // 证件类型1 value
        && this.kycName // 名
        && this.kycFamilyName // 姓
        // && this.address // 地址
      ) { // 证件号码
        flag = false;
      }
      return flag;
    },
    // 国籍
    kycNationality() {
      let str = '';
      const current = this.countryRealMap[`+${this.kycPhone}`];
      if (this.kycPhone && current) {
        const val = current.value;
        [str] = val.split(' +');
      }
      return str;
    },
    // 验证类型 1为中国人 2为外国人
    kycType() {
      if (this.kycPhone) {
        if (this.kycPhone === '156') {
          return '1';
        }
        return '2';
      }
      return '2';
    },
    appDownload() {
      return this.$store.state.baseData.app_download;
    },
  },
  methods: {
    init() {
      if (this.$route.query) {
        if (this.$route.query.country) {
          this.kycPhone = this.$route.query.country;
          this.kycPhoneCode = this.$route.query.countryKeyCode;
        } else if (this.$route.query.countryKeyCode) {
          this.kycPhone = this.countryMap[`+${this.$route.query.countryKeyCode}`].code.replace('+', '');
          this.kycPhoneCode = this.$route.query.countryKeyCode;
        } else {
          this.kycPhone = '156';
          this.kycPhoneCode = '86';
        }
      }
      if (this.publicInfo !== null) {
        this.isOpenUploadImg = this.publicInfo.switch.is_open_upload_img;
      }
      if (this.userInfo) {
        this.authLevel = this.userInfo.authLevel;
        if (this.authLevel === 2 || this.authLevel === 3) {
          this.active = '1';
        } else if (this.authLevel === 0) {
          this.active = '3';
        } else {
          // this.authLevel为1 审核通过
          this.$router.push('/personal/userManagement');
        }
      }
      if (this.interfaceSwitch) {
        this.getLang();
      }
    },
    getLang() {
      this.axios({
        url: '/kyc/Api/getUploadImgCopywriting',
      }).then((data) => {
        if (data.code.toString() === '0') {
          if (data.data.language) {
            this.kycMetaText = data.data.language;
          }
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    certificateType1Change({ code }) {
      this.certificateType1 = code;
      this.certificateType2Options = this.idAuthType.filter((item) => item.code
        !== this.certificateType1);
      this.idAuthType.forEach((item) => {
        if (item && item.code === code) {
          this.certificateType1NumPromptText = this.$t(`personal.kyc.value${code}`);
        }
      });
    },
    certificateType2Change({ code }) {
      this.certificateType2 = code;
      this.certificateType1Options = this.idAuthType.filter((item) => item.code
        !== this.certificateType2);
      this.idAuthType.forEach((item) => {
        if (item && item.code === code) {
          this.certificateType2NumPromptText = this.$t(`personal.kyc.value${code}`);
        }
      });
    },
    certificateTypeInputChange(value, name) {
      this[name] = value;
    },
    idAuthTypeChange({ code }) {
      this.certificateType = code;
    },
    uploadFinish(obj) {
      if (obj.name) {
        this.uploadName = obj.name;
      }
      if (obj.error) {
        this.$bus.$emit('tip', { text: obj.error, type: 'error' });
        return;
      }
      this[`${this.uploadName}Img`] = obj.url;
      this[`${this.uploadName}Loading`] = false;
      this[this.uploadName] = obj.fileName;
      if (
        this.firstPhotoImg
        // && this.secondPhotoImg
        // && this.thirdPhotoImg
        // && this.fourthPhotoImg
        // && this.fifthPhotoImg
        // && this.sixthPhotoImg
      ) {
        this.disabled2 = false;
      }
    },
    onChangeFileFun(obj) {
      if (obj.code && obj.code === 'maxSize') {
        this.$bus.$emit('tip', { text: this.$t('personal.exccAuthForm.text3'), type: 'error' });
      }
      this.uploadName = obj.name;
      this[`${this.uploadName}Loading`] = true;
    },
    inputChanges(value, name) {
      // 中国 - 姓名
      if (name === 'name') {
        this.checkValue2 = value;
      // 外国 - 姓
      } else if (name === 'kycFamilyName') {
        this.kycFamilyName = value;
      // 外国 - 名
      } else if (name === 'kycName') {
        this.kycName = value;
      // 证件号码
      } else {
        this.checkValue1 = value;
      }
    },
    checkFocus(name) {
      switch (name) {
        case 'email': {
          // email
          this.checkErrorFlag1 = false;
          this.errorText1 = '';
          break;
        }
        case '2': {
          // emailCode
          break;
        }
        default: {
          // newpassword again
        }
      }
    },
    btnLink(num) {
      if (num === 1) {
        this.active = '2';
      } else {
        this.loading = true;
        const datas = {};
        datas.info = {
          countryCode: `+${this.kycPhoneCode}`, // 电话编码
          numberCode: this.kycPhone, // 国家代码
          // certificateType: type, // 证件类型
          // certificateNumber: this.checkValue1, // 证件号
          userName: this.checkValue2 || '', // 中国 - 姓名
          // firstPhoto: this.firstPhoto,
          // secondPhoto: this.secondPhoto,
          // thirdPhoto: this.thirdPhoto,
          familyName: this.kycFamilyName || '', // 外国姓
          name: this.kycName || '', // 外国名

          certificateNumber: this.certificateType1Value || '', // 证件1号码
          certificateType: this.certificateType1 || '', // 证件类型 1
          firstPhoto: this.firstPhoto || '', // 证件1正面
          secondPhoto: this.secondPhoto || '', // 证件1背面

          certificateNumber2: this.certificateType2Value || '', // 证件2号码
          certificateType2: this.certificateType2 || '', // 证件2类型
          thirdPhoto: this.thirdPhoto || '', // 证件2正面
          fourthPhoto: this.fourthPhoto || '', // 证件2背面

          fifthPhoto: this.fifthPhoto || '', // 地址证明
          sixthPhoto: this.sixthPhoto || '', // 手持签名

          address: this.address || '', // 地址
        };
        this.$store.dispatch('authRealname', datas);
      }
    },
  },
};
